import { render, staticRenderFns } from "./StatusData.vue?vue&type=template&id=54c567ec&scoped=true"
import script from "./StatusData.vue?vue&type=script&lang=ts"
export * from "./StatusData.vue?vue&type=script&lang=ts"
import style0 from "./StatusData.vue?vue&type=style&index=0&id=54c567ec&prod&lang=css"
import style1 from "./StatusData.vue?vue&type=style&index=1&id=54c567ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c567ec",
  null
  
)

export default component.exports